import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './CodeBlock.module.scss';

interface Props {
  code: string;
  lang?: string;
}

const CodeBlock = ({ code, lang }: Props) => {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);
  const lines = code.split('\n');

  const handleCopy = () => {
    navigator.clipboard.writeText(code).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div className={styles.wrapper}>
      {lang && <span className={styles.lang}>{lang}</span>}

      <button
        type='button'
        className={`${styles.copyBtn} ${copied ? styles.copyBtnCopied : ''}`}
        onClick={handleCopy}
        aria-label={t('blog.copyCode')}
      >
        {copied ? (
          <>
            <svg width='13' height='13' viewBox='0 0 13 13' fill='none' aria-hidden='true'>
              <polyline
                points='2,7 5,10 11,3'
                stroke='currentColor'
                strokeWidth='1.8'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </svg>
            {t('blog.copied')}
          </>
        ) : (
          <>
            <svg width='13' height='13' viewBox='0 0 13 13' fill='none' aria-hidden='true'>
              <rect x='4' y='4' width='7' height='8' rx='1.5' stroke='currentColor' strokeWidth='1.4' />
              <path
                d='M9 4V2.5A1.5 1.5 0 0 0 7.5 1h-5A1.5 1.5 0 0 0 1 2.5v7A1.5 1.5 0 0 0 2.5 11H4'
                stroke='currentColor'
                strokeWidth='1.4'
                strokeLinecap='round'
              />
            </svg>
            {t('blog.copy')}
          </>
        )}
      </button>

      <pre className={styles.pre}>
        <code>
          {lines.map((line, i) => (
            <span key={i} className={styles.line}>
              <span className={styles.lineNum}>{i + 1}</span>
              <span className={styles.lineContent}>{line}</span>
            </span>
          ))}
        </code>
      </pre>
    </div>
  );
};

export default CodeBlock;
